module.exports = __webpack_public_path__ + "img/refund-2-fill.e8277b22.svg";